module.exports = __webpack_public_path__ + "media/images/menu/pisces-21d486ca4240ba6dc4fe0de05eb7f00d.jpg";